export default [
  {value: 'file', label: 'File'},
  {value: 'link', label: 'Link'},
]
